/* eslint-disable no-script-url */
import { MenuExclusionList } from 'common/constants'
import { NavLink } from 'components/Share/Link'
import { LayoutContext } from 'contexts/LayoutContext'
import { useContext } from 'react'
import { Nav } from 'react-bootstrap'
import { useGlobalStore } from 'store/useGlobalStore'
import { setCustomClick } from 'utils/analyticsUtils'
import shallow from 'zustand/shallow'

import { resetSRPFilter } from 'utils/menuUtils'
import { StyledCloseMenuButton, StyledMainNav, StyledNavBar, StyledUnderlineSpan } from './NavBar.styled'
import { SubMenu } from './SubMenu'
import { UserMenu } from './UserMenu'
import { useLocation } from 'react-router-dom'

interface IProps {
  isSticky?: boolean
  assetFolder?: string
}

export const NavBar = ({ isSticky, assetFolder }: IProps) => {
  const { pathname } = useLocation()
  const { showMenuSidebar, setShowMenuSidebar } = useContext(LayoutContext)
  const [isTerm, menu] = useGlobalStore((state) => [state.userClaims.IsTermAccepted, state.userClaims.Menu], shallow)

  const handleMenuClick = (e: any) => {
    resetSRPFilter()
    setCustomClick(`Tab Menu: ${e.target.textContent.trim()}`)
  }

  return (
    <StyledNavBar show={showMenuSidebar}>
      <StyledMainNav show={showMenuSidebar} isSticky={isSticky} assetFolder={assetFolder}>
        <StyledCloseMenuButton onClick={() => setShowMenuSidebar(false)}>x</StyledCloseMenuButton>
        <Nav as="ul">
          {isTerm &&
            menu?.Children.filter(
              (item) => item.IsWebMenu && (item.Children.length > 0 || item.URL !== 'javascript:')
            ).map((item) => (
              <Nav.Item key={item.MenuItem.Text} as="div">
                <NavLink to={item.URL === 'javascript:' ? null : item.URL} onClick={handleMenuClick}>
                  <StyledUnderlineSpan
                    className={item.URL === pathname || item.URL.slice(2) === pathname ? 'active' : ''}
                    isSticky={isSticky}
                    assetFolder={assetFolder}
                    data-text={item.MenuItem.Text}
                  >
                    {item.MenuItem.Text}
                  </StyledUnderlineSpan>
                </NavLink>
                {item.Children && (
                  <SubMenu
                    isSticky={isSticky}
                    onClick={() => setShowMenuSidebar(false)}
                    assetFolder={assetFolder}
                    items={item.Children.filter(
                      (c) =>
                        !MenuExclusionList.find((e) => e.name === item.MenuItem.Name)?.childrens?.includes(
                          c.MenuItem.Name
                        )
                    )}
                  />
                )}
              </Nav.Item>
            ))}
          {showMenuSidebar && <UserMenu showInMobile={showMenuSidebar} isSticky={isSticky} assetFolder={assetFolder} />}
        </Nav>
      </StyledMainNav>
    </StyledNavBar>
  )
}
